import { RouteType } from "../../../types/RouteType";
import RootStore from "../../../stores/RootStore";
import PanelDesignCenterStore from "./PanelDesignCenter.Store";

const panelDesignCenterRoute: RouteType = {
    name: "Panel Design Center",
    path: "/crm/panel-design-center/:jobId?/:panelId?",
    defaultParams: {
        jobId: null,
        panelId: null,
    },
    layout: "/app",
    viewportCard: {
        header: {
            component: () => import("./PanelDesignCenter.Header"),
            title: "Panel Design Center",
            color: "primary",
            enableRefreshButton: true,
            enableBackButton: true,
        },
        body: {
            component: () => import("./PanelDesignCenter.Container"),
            grayBackground: false,
        },
    },
    group: 'CRM',
  requiresAuth: true,
    requiresPermission: false,
    beforeEnter: async ({ rootStore, params }) => {
        try {
            const panelDesignStore = rootStore.panelDesignCenterStore as PanelDesignCenterStore;
            if (panelDesignStore) {
                await panelDesignStore.initializeDesignCenter(
                    params.jobId && typeof params.jobId === 'string' ? params.jobId : undefined,
                    params.panelId && typeof params.panelId === 'string' ? params.panelId : undefined
                );
            }
            return true;
        } catch (error) {
            console.error("Failed to initialize panel design center:", error);
            return false;
        }
    },
    onParamsChange: async ({ rootStore, params, previousParams }) => {
        if (params.jobId !== previousParams?.jobId || params.panelId !== previousParams?.panelId) {
            const panelDesignStore = rootStore.panelDesignCenterStore as PanelDesignCenterStore;
            if (panelDesignStore) {
                await panelDesignStore.initializeDesignCenter(
                    params.jobId && typeof params.jobId === 'string' ? params.jobId : undefined,
                    params.panelId && typeof params.panelId === 'string' ? params.panelId : undefined
                );
            }
        }
    },
    dialogs: [
        {
            name: "panelTemplateDialog",
            component: () => import("./PanelTemplateDialog"),
            title: "Select Panel Template",
            onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
                // Dialog components manage their own form state
                // The actual template selection logic would be implemented here
                console.log("Panel template dialog submitted");
                return true;
            },
            onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
                // For now, always return true as validation is handled in the dialog
                return true;
            },
            cancelButton: true,
            height: 500,
        },
        {
            name: "saveDesignDialog",
            component: () => import("./SaveDesignDialog"),
            title: "Save Panel Design",
            onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
                // Dialog components manage their own form state
                // The actual save logic would be implemented here
                console.log("Save design dialog submitted");
                return true;
            },
            onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
                // For now, always return true as validation is handled in the dialog
                return true;
            },
            cancelButton: true,
        },
        {
            name: "designReviewDialog",
            component: () => import("./DesignReviewDialog"),
            title: "Submit for Design Review",
            onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
                // Dialog components manage their own form state
                // The actual review submission logic would be implemented here
                console.log("Design review dialog submitted");
                return true;
            },
            onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
                // For now, always return true as validation is handled in the dialog
                return true;
            },
            cancelButton: true,
        },
    ],
};

export default panelDesignCenterRoute;
